export const TYPES = {
  IReportConfigProvider: Symbol.for('Reporting/IReportConfigProvider'),
  IReportDataGathererFactory: Symbol.for('Reporting/IReportDataGathererFactory'),
  IReportRendererFactory: Symbol.for('Reporting/IReportRendererFactory'),
  CreateReportUseCase: Symbol.for('Reporting/CreateReportUseCase'),
  IReportLifecycle: Symbol.for('Reporting/IReportLifecycle')
};
